import React from 'react';

export default function Row({ children, classes = '' }) {
  return <div className={`row ${classes}`}>{children}</div>;
}
